export default (dir: string, page: string) => {
  return () => import(`@/views/${dir}/${page}.vue`);
};
